import styled, { css } from 'styled-components';
import {
  mq,
  getTextType,
  borderClipPath,
  getSpace,
  px2rem,
  getTransition
} from '../../../stylesheets/tools';

const disabledColor = 'gray';

const StyledInput = styled.div`
  .input__inner {
    position: relative;
  }

  input {
    position: relative;
    z-index: 1;
    width: 100%;
    background: none;
    margin: 0;
    border: none;
    outline: 0;

    &::-ms-clear {
      display: none;
    }

    &::placeholder {
      text-transform: uppercase;
    }
  }

  ${props =>
    props.variant === 'default' &&
    css`
      ${getTextType('subline')}
      position: relative;
      height: 100%;
      text-transform: uppercase;
      display: flex;
      justify-content: center;
      align-items: center;

      input {
        padding: ${getSpace('m')} ${getSpace('xxs')} ${getSpace('xxs')} ${getSpace('xxs')};
      }

      .input__inner {
        flex-grow: 2;

        ${mq(767, 'max')} {
          ${borderClipPath('#000', '#fff')}
        }
      }

      ${props.isHidden &&
        css`
          display: none;
          pointer-events: none;
        `}
      .input__wrapper {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;

        ${mq('m')} {
          ${borderClipPath('#000', '#fff')}
          justify-content: center;
          align-items: flex-end;
          flex-direction: row;
        }
      }

      .input__label {
        position: relative;
        flex-shrink: 1;
        height: 100%;
        top: 10px;
        padding-bottom: 15px;
        margin-left: 20px;
        width: 180px;
        z-index: 1;

        display: flex;
        align-items: flex-end;

        ${mq('m')} {
          top: 0;
          margin: 0;
          padding: ${getSpace('m')} ${getSpace('xxs')} ${getSpace('xxs')} ${getSpace('xxs')};
          border-right: 2px solid black;
        }
      }

      .input__required {
        font-family: arial-black;
        font-size: ${px2rem('20px')};
        display: inline-block;
        align-self: flex-start;

        ${mq('m')} {
          font-size: ${px2rem('30px')};
        }
      }

      .input__warn {
        position: absolute;
        top: 100%;
        left: 0;
        font-size: 12px;
        color: red;
        visibility: hidden;
        opacity: 0;
        padding: 10px 20px;
        ${getTransition('inputError')}
      }
    `}

  ${props =>
    props.variant === 'simple' &&
    css`
      ${getTextType('copy')}
      text-transform: uppercase;
      font-weight: 400;
      input {
        padding: ${getSpace('s')} ${getSpace('xxs')} ${getSpace('s')} ${getSpace('xxs')};
      }

      .input__label {
        padding-bottom: 4px;
      }
      .input__inner {
        position: relatve;
        ${borderClipPath('#000', '#fff')}
      }
      .input__icon {
        position: absolute;
        right: ${getSpace('s')};
        top: 50%;
        transform: translateY(-50%);
        z-index: 1;
        cursor: pointer;
      }
    `}

  ${props =>
    props.error &&
    css`
      .input__wrapper {
        ${mq('m')} {
          ${borderClipPath('red', '#fff')}
        }
      }

      .input__inner {
        ${mq(767, 'max')} {
          ${borderClipPath('red', '#fff')}
        }
      }

      .input__warn {
        visibility: visible;
        opacity: 1;
      }

      input,
      .input__label {
        border-color: red;
      }
    `}

  ${props =>
    props.active &&
    css`
      .input__wrapper {
        ${mq('m')} {
          ${props.theme.siteTheme &&
            css`
              ${borderClipPath(props.theme.siteTheme.focusColor, '#fff')};
            `}
        }
      }

      .input__inner {
        ${mq(767, 'max')} {
          background: ${props.theme.siteTheme.focusColor} !important;
          ${props.theme.siteTheme &&
            css`
              ${borderClipPath(props.theme.siteTheme.focusColor, '#fff')}
            `}
        }
      }

      ${props.theme.siteTheme &&
        css`
          input,
          .input__label {
            border-color: ${props.theme.siteTheme.focusColor};
          }
        `}
    `}

  ${props =>
    props.disabled &&
    css`
      .input__wrapper {
        ${mq('m')} {
          ${borderClipPath(disabledColor, '#fff')}
        }
      }

      .input__inner {
        ${mq(767, 'max')} {
          ${borderClipPath(disabledColor, '#fff')}
        }
      }

      input {
        border-color: ${disabledColor};
      }

      .input__label {
        color: ${disabledColor};
      }
    `}
`;

export default StyledInput;
